var map = {
	"./ColorPicker": [
		4687,
		9,
		478,
		687
	],
	"./ColorPicker.tsx": [
		4687,
		9,
		478,
		687
	],
	"./CursorSegmentBuilder": [
		9337,
		9,
		337
	],
	"./CursorSegmentBuilder.tsx": [
		9337,
		9,
		337
	],
	"./Patterns": [
		638,
		9,
		638
	],
	"./Patterns.tsx": [
		638,
		9,
		638
	],
	"./SegmentBuilder": [
		6375,
		9,
		375
	],
	"./SegmentBuilder.tsx": [
		6375,
		9,
		375
	],
	"./TemplatePage": [
		1664,
		9,
		664
	],
	"./TemplatePage.tsx": [
		1664,
		9,
		664
	],
	"./TestLayout": [
		7169,
		9,
		169
	],
	"./TestLayout.tsx": [
		7169,
		9,
		169
	],
	"./pages-registry": [
		8876,
		3
	],
	"./pages-registry.json": [
		8876,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2085;
module.exports = webpackAsyncContext;